// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.listIcon {
  color: white;
  margin-left: 0.2em;
}

.activeLink {
  background: var(--primaryColor);
}

.container {

  /*overscroll-behavior: none;*/
}

.container::-webkit-scrollbar {
  width: 2%;
}

.container::-webkit-scrollbar-track {
  background: #282c34;
}

.container::-webkit-scrollbar-thumb {
  background-color: var(--primaryColor);
}
`, "",{"version":3,"sources":["webpack://./src/dashboard_layout/DashboardLayout.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC","sourcesContent":[".listIcon {\n  color: white;\n  margin-left: 0.2em;\n}\n\n.activeLink {\n  background: var(--primaryColor);\n}\n\n.container {\n\n  /*overscroll-behavior: none;*/\n}\n\n.container::-webkit-scrollbar {\n  width: 2%;\n}\n\n.container::-webkit-scrollbar-track {\n  background: #282c34;\n}\n\n.container::-webkit-scrollbar-thumb {\n  background-color: var(--primaryColor);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
